// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewCommentsList.test.tsx
import { CaretUp } from "@phosphor-icons/react";
import { type ReactNode } from "react";

/**
 * One section of the Ask v2 findings list: its heading, the toggle with the
 * count, and the list it opens. Presentational -- which findings sit in it and
 * whether it is open belong to `AskV2ReviewCommentsList`.
 */
export function AskV2ReviewCommentSection({
  sectionKey,
  label,
  count,
  open,
  listId,
  onToggle,
  children,
}: {
  sectionKey: string;
  label: string;
  count: number;
  open: boolean;
  listId: string;
  onToggle: () => void;
  children: ReactNode;
}) {
  return (
    <li className="mb-3" data-testid={`ask-v2-review-section-${sectionKey}`}>
      <h3
        className="m-0"
        data-testid={`ask-v2-review-section-${sectionKey}-heading`}
      >
        <button
          type="button"
          className="mb-2 flex w-full items-center gap-2 rounded-md px-1 py-2 text-left text-[15px] font-semibold text-puntt-neutral-gray-12 hover:bg-puntt-neutral-gray-3"
          data-testid={`ask-v2-review-section-${sectionKey}-toggle`}
          aria-expanded={open}
          // why: a closed section's list is not rendered, and aria-controls
          // must name an element that exists.
          aria-controls={open ? listId : undefined}
          onClick={onToggle}
        >
          <CaretUp
            size={14}
            weight="bold"
            aria-hidden="true"
            className={open ? "" : "rotate-180"}
          />
          <span>{label}</span>
          <span
            className="font-medium text-puntt-neutral-gray-10"
            data-testid={`ask-v2-review-section-${sectionKey}-count`}
          >
            {count}
          </span>
        </button>
      </h3>
      {open ? (
        <ul
          id={listId}
          data-testid={`ask-v2-review-section-${sectionKey}-list`}
        >
          {children}
        </ul>
      ) : null}
    </li>
  );
}
